import { combineReducers } from 'redux';
import progress from './importProgress';
import request from './importRequest';
export default combineReducers({
  progress,
  request
});